// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__wynOv","consentGrid":"CookieModal_consentGrid__fKcKt","buttonGrid":"CookieModal_buttonGrid__c8Hgo","consentModal":"CookieModal_consentModal__JHGJF"};